import React, { useState, useEffect } from   'react';
import {NavLink, useNavigate, useParams } from 'react-router-dom';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import apiService from '../../Auth/apiService';
import MenuPersonasSSV from './MenuPersonasSSV';
import { useAuth } from '../../Auth/AuthContext';
import CargandoSpinner from '../Utils/CargandoSpinner';
import { useForm } from 'react-hook-form';
import { Card, CardHeader, CardBody, CardFooter, Button, Form, Row, Col, FormGroup } from 'react-bootstrap';
import { FaSave, FaArrowAltCircleRight } from 'react-icons/fa';
import moment from 'moment';
function CalcularEdad(date){
    return moment().diff(date, 'years');
}

export default function SSVOtrosIngresos() {
    const { token } = useAuth();
    const { idEncuesta, idPersona } = useParams();
    const [Cargando, setCargando] = useState(false);
    const [edad, setEdad] = useState('');
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const defaultValues = {
        id: 0,
        idenc_idficha: '',
    };
    const { watch, handleSubmit, register, setValue, getValues, reset, trigger, control, formState: { errors }} = useForm({ 
            defaultValues: defaultValues
        }
    );
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const fetchData = async (idPersona, idEncuesta) => {
        let url = `/encuestassv/otrosingresos/crearformulariootrosingresos`;
        let obj = { idPersona: idPersona, idEncuesta: idEncuesta };
        await apiService.post(url, obj, token)
        .then(response => {
            const result = response.data;

            resetForm(result.datosOtrosIngresos);
            console.log('Datos de otros ingresos obtenidos:', result);
        })
        .catch(error => {
            if (error?.response?.data?.message) {
                Mensaje('Error', error.response.data.message);
            } else {
                Mensaje('Error', 'No se pudieron obtener los datos de otros ingresos de la persona.');
            }
        })
        .finally(() => {
            setCargando(false);
        });
    };
  
    const resetForm = (data) => {
        try {
            if (data) {
                reset((prevValues) => ({
                    ...prevValues,
                    id: data.id || '',
                    cons_ficha_id: data.cons_ficha_id || '',
                    nombre: data.nombre || '',
                    edad_calculada: data.edad_calculada || '',
                    otros_ingresos_mes_pasado_recibio_casas: data.otros_ingresos_mes_pasado_recibio_casas || 0,
                    otros_ingresos_valor_arriendos: data.otros_ingresos_valor_arriendos || 0,
                    otros_ingresos_mes_pasado_recibio_jubilaciones: data.otros_ingresos_mes_pasado_recibio_jubilaciones || 0,
                    otros_ingresos_valor_jubilaciones: data.otros_ingresos_valor_jubilaciones || 0,
                    otros_ingresos_mes_pasado_pension_alimentos: data.otros_ingresos_mes_pasado_pension_alimentos || 0,
                    otros_ingresos_valor_pension_alimentos: data.otros_ingresos_valor_pension_alimentos || 0,
                    otros_ingresos_no_recibio_pagos: data.otros_ingresos_no_recibio_pagos || 0,
                    ot_ultimos_12_meses_recibio_dinero_personas_en_el_pais: data.ot_ultimos_12_meses_recibio_dinero_personas_en_el_pais || 0,
                    ot_ultimos_12_meses_recibio_dinero_personas_en_el_pais_valor: data.ot_ultimos_12_meses_recibio_dinero_personas_en_el_pais_valor || 0,
                    ot_ultimos_12_meses_recibio_dinero_personas_fuera_el_pais: data.ot_ultimos_12_meses_recibio_dinero_personas_fuera_el_pais || 0,
                    ot_ultimos_12_meses_recibio_dinero_personas_fuera_el_pais_valor: data.ot_ultimos_12_meses_recibio_dinero_personas_fuera_el_pais_valor || 0,
                    ot_ultimos_12_meses_recibio_dinero_inst_fuera_o_en_el_pais: data.ot_ultimos_12_meses_recibio_dinero_inst_fuera_o_en_el_pais || 0,
                    ot_ultimos_12_meses_recibio_dinero_inst_fuera_o_en_el_pais_valo: data.ot_ultimos_12_meses_recibio_dinero_inst_fuera_o_en_el_pais_valo || 0,
                    ot_ultimos_12_meses_recibio_intereses_prestamos: data.ot_ultimos_12_meses_recibio_intereses_prestamos || 0,
                    ot_ultimos_12_meses_recibio_intereses_prestamos_valor: data.ot_ultimos_12_meses_recibio_intereses_prestamos_valor || 0,
                    ot_ultimos_12_meses_recibio_intereses_cesantias: data.ot_ultimos_12_meses_recibio_intereses_cesantias || 0,
                    ot_ultimos_12_meses_recibio_intereses_cesantias_valor: data.ot_ultimos_12_meses_recibio_intereses_cesantias_valor || 0,
                    ot_recibio_dineros_otras_fuentes_ultimos_12_meses: data.ot_recibio_dineros_otras_fuentes_ultimos_12_meses || 0,
                    ot_recibio_dineros_otras_fuentes_ultimos_12_meses_valor: data.ot_recibio_dineros_otras_fuentes_ultimos_12_meses_valor || 0,
                    otros_ingresos_no_recibio_dinero_otros_ingresos: data.otros_ingresos_no_recibio_dinero_otros_ingresos || 0,
                    otros_ingresos_recibio_subsidio_alimentacion: data.otros_ingresos_recibio_subsidio_alimentacion || 0,
                    otros_ingresos_recibio_subsidio_alimentacion_valor: data.otros_ingresos_recibio_subsidio_alimentacion_valor || 0,
                    otros_ingresos_recibio_subsidio_transporte: data.otros_ingresos_recibio_subsidio_transporte || 0,
                    otros_ingresos_recibio_subsidio_transporte_valor: data.otros_ingresos_recibio_subsidio_transporte_valor || 0,
                    otros_ingresos_recibio_subsidio_familiar: data.otros_ingresos_recibio_subsidio_familiar || 0,
                    otros_ingresos_recibio_subsidio_familiar_valor: data.otros_ingresos_recibio_subsidio_familiar_valor || 0,
                    otros_ingresos_recibio_subsidio_educativo: data.otros_ingresos_recibio_subsidio_educativo || 0,
                    otros_ingresos_recibio_subsidio_educativo_valor: data.otros_ingresos_recibio_subsidio_educativo_valor || 0,
                    otros_ingresos_recibio_subsidio_discapacidad: data.otros_ingresos_recibio_subsidio_discapacidad || 0,
                    otros_ingresos_recibio_subsidio_discapacidad_valor: data.otros_ingresos_recibio_subsidio_discapacidad_valor || 0,
                    otros_ingresos_recibio_subsidio_personasmayores: data.otros_ingresos_recibio_subsidio_personasmayores || 0,
                    otros_ingresos_recibio_subsidio_personasmayoresvalor: data.otros_ingresos_recibio_subsidio_personasmayoresvalor || 0,
                    otros_ingresos_recibio_subsidiootro: data.otros_ingresos_recibio_subsidiootro || 0,
                    otros_ingresos_recibio_subsidiootrocual: data.otros_ingresos_recibio_subsidiootrocual || '',
                    otros_ingresos_recibio_subsidiootrocualvalor: data.otros_ingresos_recibio_subsidiootrocualvalor || 0,
                    otros_ingresos_no_recibio_subsidio: data.otros_ingresos_no_recibio_subsidio || 0,
                    otros_ingresos_observacion: data.otros_ingresos_observacion || '',
                }))
                setEdad(CalcularEdad(data.datos_basicos_fecha_nacimiento));
            }
        } catch (error) {
            console.error('Error al resetear el formulario:', error);
        }
    };
    useEffect(() => {
        fetchData(idPersona, idEncuesta);
    }, [idPersona, idEncuesta]);

    async function GuardarDatosOtrosIngresos() {
        const valid = await trigger(); 
        if (!valid) {
            setSwalProps({
                show: true,
                title: 'Validar formulario',
                text: 'Por favor complete el formulario correctamente antes de guardar.',
                icon: 'warning',
            });
            return;
        }
        const datosFormulario = getValues();
        let url = `/encuestassv/otrosingresos/guardardatosotrosingresos`;
        
        setCargando(true);
        await apiService.post(url, datosFormulario, token)
        .then(response => {
            const result = response.data;
            if (response.status === 200) {
                Mensaje('Guardar', result.message + ' Id: ' + result.id);
            } else {
                Mensaje('Error', 'No se pudieron guardar los datos de otros ingresos de la persona.');
            }
        })
        .catch(error => {
            if (error?.response?.data?.message) {
                Mensaje('Error', error.response.data.message);
            } else {
                Mensaje('Error', 'No se pudieron guardar los datos de otros ingresos de la persona.' + (error.message || ''));
            }
        })
        .finally(() => {
            setCargando(false);
        });
    }
  
    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">SSV Personas Otros Ingresos</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item"><NavLink to={`/encuestassv/id/${idEncuesta}`} > Ficha</NavLink></li>
                        <li className="breadcrumb-item active"> Otros Ingresos</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                        {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                        </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuPersonasSSV idEncuesta={idEncuesta} idPersona={idPersona}></MenuPersonasSSV>
                    <hr />
                    <Form onSubmit={handleSubmit(GuardarDatosOtrosIngresos)}>
                        <Card>
                            <CardHeader>
                                <h2>Para cada integrante de la familia</h2>
                                <b>Aplica para todas las personas de 10 años y mas. Para menores de 15 años, contesta el informante indóneo</b>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col md={2}>
                                    <Form.Group>
                                        <label htmlFor="id">id</label>
                                        <input readOnly className="form-control" id="id" placeholder="id" type="text" {...register('id')} />
                                    </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                    <Form.Group>
                                        <label htmlFor="nombre">Nombre de la persona</label>
                                        <input readOnly className="form-control" id="nombre" placeholder="Nombre" type="text" {...register('nombre')} />
                                    </Form.Group>
                                    </Col>
                                    <Col md={2}>
                                    <Form.Group>
                                        <label htmlFor="edad">Edad</label>
                                        <input readOnly className="form-control" id="edad" placeholder="Edad" type="text" value={edad}/>
                                    </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <Form.Label>1. El mes pasado recibió pagos por: (Selección múltiple)</Form.Label>
                                        <Row>
                                            <Col md={4}>
                                                <Form.Check
                                                    id="otros_ingresos_mes_pasado_recibio_casas"
                                                    type="checkbox"
                                                    label="1. Arriendos de casas, apartamentos, fincas, lotes, vehículos, equipos, etc."
                                                    {...register('otros_ingresos_mes_pasado_recibio_casas')}
                                                />
                                                <Form.Control id="otros_ingresos_valor_arriendos" placeholder="Valor mes pasado" type="text" {...register('otros_ingresos_valor_arriendos')} />
                                            </Col>
                                            <Col md={4}>
                                                <Form.Check
                                                    id="otros_ingresos_mes_pasado_recibio_jubilaciones"
                                                    type="checkbox"
                                                    label="2. Pensiones o jubilaciones por vejez, invalidez o sustitución pensional."
                                                    {...register('otros_ingresos_mes_pasado_recibio_jubilaciones')}
                                                />
                                                <Form.Control id="otros_ingresos_valor_jubilaciones" placeholder="Valor mes pasado" type="text" {...register('otros_ingresos_valor_jubilaciones')} />
                                            </Col>
                                            <Col md={4}>
                                                <Form.Check
                                                    id="otros_ingresos_mes_pasado_pension_alimentos"
                                                    type="checkbox"
                                                    label="3. Pensión alimenticia por paternidad, divorcio o separación."
                                                    {...register('otros_ingresos_mes_pasado_pension_alimentos')}
                                                />
                                                <Form.Control id="otros_ingresos_valor_pension_alimentos" placeholder="Valor mes pasado" type="text" {...register('otros_ingresos_valor_pension_alimentos')} />
                                            </Col>
                                        </Row>
                                        <Row className="mt-2">
                                            <Col md={4}>
                                                <Form.Check
                                                    id="otros_ingresos_no_recibio_pagos"
                                                    type="checkbox"
                                                    label="4. No recibió"
                                                    {...register('otros_ingresos_no_recibio_pagos')}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={12}>
                                    <Form.Label>2. Durante los últimos 12 meses recibió: (Selección mútiple)</Form.Label>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Check
                                                id="ot_ultimos_12_meses_recibio_dinero_personas_en_el_pais"
                                                type="checkbox"
                                                label="1. ¿Dinero de otros hogares o personas residentes en el país?"
                                                {...register('ot_ultimos_12_meses_recibio_dinero_personas_en_el_pais')}
                                            />
                                            <Form.Control id="ot_ultimos_12_meses_recibio_dinero_personas_en_el_pais_valor" placeholder="Valor" type="text" {...register('ot_ultimos_12_meses_recibio_dinero_personas_en_el_pais_valor')}/>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Check
                                                id="ot_ultimos_12_meses_recibio_dinero_personas_fuera_el_pais"
                                                type="checkbox"
                                                label="2. ¿Dinero de otros hogares o personas residentes fuera del país?"
                                                {...register('ot_ultimos_12_meses_recibio_dinero_personas_fuera_el_pais')}
                                            />
                                            <Form.Control id="ot_ultimos_12_meses_recibio_dinero_personas_fuera_el_pais_valor" placeholder="Valor" type="text" {...register('ot_ultimos_12_meses_recibio_dinero_personas_fuera_el_pais_valor')}/>
                                        </Col>
                                    </Row>
                                    <Row className="mt-2">
                                        <Col md={6}>
                                            <Form.Check
                                                id="ot_ultimos_12_meses_recibio_dinero_inst_fuera_o_en_el_pais"
                                                type="checkbox"
                                                label="3. ¿Ayudas en dinero de instituciones del país o de fuera del país?"
                                                {...register('ot_ultimos_12_meses_recibio_dinero_inst_fuera_o_en_el_pais')}
                                            />
                                            <Form.Control id="ot_ultimos_12_meses_recibio_dinero_inst_fuera_o_en_el_pais_valor" placeholder="Valor" type="text" {...register('ot_ultimos_12_meses_recibio_dinero_inst_fuera_o_en_el_pais_valor')}/>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Check
                                                id="ot_ultimos_12_meses_recibio_intereses_prestamos"
                                                type="checkbox"
                                                label="4. ¿Dinero por intereses de préstamo o por CDT's, depósitos de ahorro, utilidades, ganancias o dividendos por inversiones?"
                                                {...register('ot_ultimos_12_meses_recibio_intereses_prestamos')}
                                            />
                                            <Form.Control id="ot_ultimos_12_meses_recibio_intereses_prestamos_valor" placeholder="Valor" type="text" {...register('ot_ultimos_12_meses_recibio_intereses_prestamos_valor')}/>
                                        </Col>
                                    </Row>
                                    <Row className="mt-2">
                                        <Col md={6}>
                                            <Form.Check
                                                id="ot_ultimos_12_meses_recibio_intereses_cesantias"
                                                type="checkbox"
                                                label="5. ¿Ingresos por concepto de cesantías y/o intereses a las cesantías?"
                                                {...register('ot_ultimos_12_meses_recibio_intereses_cesantias')}
                                            />
                                            <Form.Control id="ot_ultimos_12_meses_recibio_intereses_cesantias_valor" placeholder="Valor" type="text" {...register('ot_ultimos_12_meses_recibio_intereses_cesantias_valor')}/>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Check
                                                id="ot_recibio_dineros_otras_fuentes_ultimos_12_meses"
                                                type="checkbox"
                                                label="6. Dinero de otras fuentes diferentes a las anteriores (ingresos por ganancias en juegos de azar, chances, loterías, indemnizaciones, liquidaciones, venta de propiedades, acciones, vehículos, etc.)"
                                                {...register('ot_recibio_dineros_otras_fuentes_ultimos_12_meses')}
                                            />
                                            <Form.Control id="ot_recibio_dineros_otras_fuentes_ultimos_12_meses_valor" placeholder="Valor" type="text" {...register('ot_recibio_dineros_otras_fuentes_ultimos_12_meses_valor')}/>
                                        </Col>
                                    </Row>
                                    <Row className="mt-2">
                                        <Col md={6}>
                                            <Form.Check
                                                id="otros_ingresos_no_recibio_dinero_otros_ingresos"
                                                type="checkbox"
                                                label="7. No recibió"
                                                {...register('otros_ingresos_no_recibio_dinero_otros_ingresos')}

                                            />
                                        </Col>
                                    </Row>
                                    </Col>
                                    <Col md={12}>
                                    <Form.Label>3. ¿Cuál o cuáles de los siguientes subsidios recibió el mes pasado? (Selección múltiple)</Form.Label>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Check
                                                id="otros_ingresos_recibio_subsidio_alimentacion"
                                                type="checkbox"
                                                label="1. Subsidio de alimentacion"
                                                {...register('otros_ingresos_recibio_subsidio_alimentacion')}

                                            />
                                            <Form.Control id="otros_ingresos_recibio_subsidio_alimentacion_valor" placeholder="Valor" type="text" {...register('otros_ingresos_recibio_subsidio_alimentacion_valor')}/>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Check
                                                id="otros_ingresos_recibio_subsidio_transporte"
                                                type="checkbox"
                                                label="2. Subsidio de transporte"
                                                {...register('otros_ingresos_recibio_subsidio_transporte')}
                                            />
                                            <Form.Control id="otros_ingresos_recibio_subsidio_transporte_valor" placeholder="Valor" type="text" {...register('otros_ingresos_recibio_subsidio_transporte_valor')}/>
                                        </Col>
                                    </Row>
                                    <Row className="mt-2">
                                        <Col md={6}>
                                            <Form.Check
                                                id="otros_ingresos_recibio_subsidio_familiar"
                                                type="checkbox"
                                                label="3. Subsidio familiar"
                                                {...register('otros_ingresos_recibio_subsidio_familiar')}
                                            />
                                            <Form.Control id="otros_ingresos_recibio_subsidio_familiar_valor" placeholder="Valor" type="text" {...register('otros_ingresos_recibio_subsidio_familiar_valor')}/>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Check
                                                id="otros_ingresos_recibio_subsidio_educativo"
                                                type="checkbox"
                                                label="4. Subsidio educativo"
                                                {...register('otros_ingresos_recibio_subsidio_educativo')}
                                            />
                                            <Form.Control id="otros_ingresos_recibio_subsidio_educativo_valor" placeholder="Valor" type="text" {...register('otros_ingresos_recibio_subsidio_educativo_valor')}/>
                                        </Col>
                                    </Row>
                                    <Row className="mt-2">
                                        <Col md={6}>
                                            <Form.Check
                                                id="otros_ingresos_recibio_subsidio_discapacidad"
                                                type="checkbox"
                                                label="5. Subsidio por discapacidad"
                                                {...register('otros_ingresos_recibio_subsidio_discapacidad')}

                                            />
                                            <Form.Control id="otros_ingresos_recibio_subsidio_discapacidad_valor" placeholder="Valor" type="text" {...register('otros_ingresos_recibio_subsidio_discapacidad_valor')}/>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Check
                                                id="otros_ingresos_recibio_subsidio_personasmayores"
                                                type="checkbox"
                                                label="6. Subsidio por personas mayores"
                                                {...register('otros_ingresos_recibio_subsidio_personasmayores')}
                                            />
                                            <Form.Control id="otros_ingresos_recibio_subsidio_personasmayoresvalor" placeholder="Valor" type="text" {...register('otros_ingresos_recibio_subsidio_personasmayoresvalor')}/>
                                        </Col>
                                    </Row>
                                    <Row className="mt-2">
                                        <Col md={6}>
                                            <Form.Check
                                                id="otros_ingresos_recibio_subsidiootro"
                                                type="checkbox"
                                                label="7. Otro, ¿Cuál?"
                                                {...register('otros_ingresos_recibio_subsidiootro')}
                                            />
                                            <Form.Control id="otros_ingresos_recibio_subsidiootrocual" placeholder="Cual" type="text" {...register('otros_ingresos_recibio_subsidiootrocual')}/>
                                            <Form.Control id="otros_ingresos_recibio_subsidiootrocualvalor" placeholder="Valor" type="text" {...register('otros_ingresos_recibio_subsidiootrocualvalor')}/>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Check
                                                id="otros_ingresos_no_recibio_subsidio"
                                                type="checkbox"
                                                label="8. No recibió"
                                                {...register('otros_ingresos_no_recibio_subsidio')}
                                            />
                                        </Col>
                                    </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                    <Form.Group>
                                        <Form.Label>Observaciones</Form.Label>
                                        <Form.Control as="textarea" id="otros_ingresos_observacion" rows="3" placeholder="en relación a Fuerza de Trabajo u Otros ingresos, (Ejemplo: si observa EXPLOTACIÓN INFANTIL. Si este fuere el caso, colocar la anotación pero NO hacerle ningún tipo de reclamo a la familia)" {...register('otros_ingresos_observacion')}></Form.Control>
                                    </Form.Group>   
                                    </Col>
                                </Row>
                            </CardBody>
                            <CardFooter>
                                <div className="d-flex flex-wrap align-items-center" style={{ gap: '12px' }}>
                                    <Button type='submit' id="Guardar" className="btn btn-primary">
                                        <FaSave />
                                        Guardar
                                    </Button>
                                    <Button 
                                        id="Cancelar" 
                                        className="btn btn-secondary"
                                        onClick={() => {
                                            globalThis.location.href = `/encuestassv/id/${idEncuesta}`;
                                        }
                                        }>
                                        <FaArrowAltCircleRight />
                                        Volver
                                    </Button>
                                </div>
                            </CardFooter>
                        </Card>
                    </Form>
                </div>
                <SweetAlert2 {...swalProps} 
                    didClose={() => {
                        setSwalProps({})
                    }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
            
        </div>
      
  )
  }